import React from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import { useDeployStatus, useInstance } from '@hooks';
import { isDevelopment } from '@utils';
import { Statuses } from '@types';

export function EnableInDevOrDeployedOnly({
  tooltipLabel = 'Instance not deployed yet',
  children,
}: {
  tooltipLabel?: string;
  children: JSX.Element;
}): JSX.Element {
  const { deployStatus } = useDeployStatus();
  const { instance } = useInstance();
  const isDev = instance && isDevelopment(instance.environment_type);
  const isDeployComplete = deployStatus === Statuses.Complete;

  if (isDev || isDeployComplete) {
    return children;
  }

  return React.Children.map(children, (c: any) => {
    return (
      <Tooltip label={tooltipLabel}>
        <Box>
          {React.cloneElement(c, {
            ...c.props,
            pointerEvents: 'none',
            href: null,
          })}
        </Box>
      </Tooltip>
    );
  });
}
